/**
 * TanStack Query hooks for `custom-exchange-rate-per-invoice`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	customExchangeRatePerInvoiceQueryKeys,
	type CreateCustomExchangeRatePerInvoiceBody,
	type ListCustomExchangeRatePerInvoiceResponse,
	type CustomExchangeRatePerInvoiceRow,
} from "./api";

export function useCustomExchangeRatePerInvoiceList(): UseQueryResult<ListCustomExchangeRatePerInvoiceResponse, Error> {
	return useQuery({
		queryKey: customExchangeRatePerInvoiceQueryKeys.list(),
		queryFn: list,
	});
}

export function useCustomExchangeRatePerInvoiceCreate(): UseMutationResult<CustomExchangeRatePerInvoiceRow, Error, CreateCustomExchangeRatePerInvoiceBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customExchangeRatePerInvoiceQueryKeys.all });
		},
	});
}

export function useCustomExchangeRatePerInvoiceDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customExchangeRatePerInvoiceQueryKeys.all });
		},
	});
}
